module.exports = __webpack_public_path__ + "static/media/yDAI-logo.57f2f6f5.png";